<admin-table-standard [items]="result">
  <ng-template #header>
    <th class="col-md-1">{{ 'pages.tables.machine.batches.status' | translate }}</th>
    <th class="col-md-3">{{ 'pages.tables.machine.batches.channel' | translate }}</th>
    <th class="col-md-2">{{ 'pages.tables.machine.batches.pipeline' | translate }}</th>
    <th class="col-md-2">{{ 'pages.tables.machine.batches.data' | translate }}</th>
    <th class="col-md-2">{{ 'pages.tables.machine.batches.process' | translate }}</th>
    <th class="col-md-2">&nbsp;</th>
  </ng-template>
  <ng-template #first let-item>
    <td><div class="text-uppercase"><span [ngClass]="'status-badge-' + statusClass(item)" class="badge">{{ ('statuses.' + item.status) | translate}}</span></div></td>
    <td>{{item.channel.owner}} / {{item.channel.vertical}} / {{item.channel.code}}</td>
    <td>{{('pages.tables.machine.batches.common.pipeline.' + item.name) | translate}}</td>
    <td>{{('pages.tables.machine.batches.common.data.' + item.data) | translate}}</td>
    <td>{{('pages.tables.machine.batches.common.process.' + item.process) | translate}}</td>
    <td class="justify-content-around text-end">
      <a routerLink="/admin/channel/{{item.channel.owner}}/{{item.channel.vertical}}/{{item.channel.code}}" class="text-decoration-none action-buttons"><i class="bi bi-gear"></i>&nbsp;Config</a>
      <a *ngIf="item.status == 'RUNNING'" (click)="cancel(item)" class="text-decoration-none action-buttons" href="#"><i class="bi bi-stop-circle"></i>&nbsp;Cancel</a>
      <a *ngIf="item.status == 'DONE'" (click)="run(item)" class="text-decoration-none action-buttons" href="#"><i class="bi bi-play-circle"></i>&nbsp;Run</a>
    </td>
  </ng-template>
</admin-table-standard>
<div class="row d-flex justify-content-center p-2" *ngIf="all.length >= pageSize">
  <ngb-pagination class=""
                  [collectionSize]="all.length"
                  [(page)]="page"
                  [pageSize]="pageSize"
                  (pageChange)="paginate()"
  >
  </ngb-pagination>
</div>
